import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext({ dark: false, toggle: () => {} });

export function AdminThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("driveline-admin-theme") === "dark";
  });

  useEffect(() => {
    localStorage.setItem("driveline-admin-theme", dark ? "dark" : "light");
  }, [dark]);

  const value = useMemo(
    () => ({ dark, toggle: () => setDark((d) => !d) }),
    [dark]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useAdminTheme = () => useContext(ThemeContext);
